import { ArrowForwardIos } from '@mui/icons-material'
import { Avatar, Box } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import IconButton from 'components/icon-button'
import Loading from 'components/loading'
import { IOrganizationDTO } from 'data/dtos/security/i-organization-dto'
import { useHistory } from 'react-router-dom'
import { loadList } from 'services/requests'
import { stringToAvatar } from 'utils/string-to-avatar'
import { useStyles } from './styles'

const Permissions = () => {
  const classes = useStyles()
  const history = useHistory()

  const { data, isLoading } = useQuery({
    queryKey: ['organizations', 'list', 'permissions'],
    queryFn: () =>
      loadList('/organizations/list', {
        search: '',
        page: 0,
        rowsPerPage: 100,
        columnOrder: [],
        organizationId: '',
      }),
    initialData: { data: { data: [] } } as any,
    select: (data) => data.data.data,
  })

  const organizations: IOrganizationDTO[] = data

  const handleNavigateToOrganization = (id: string) => {
    history.push(`/cofre-digital/info/${id}`)
  }

  if (isLoading) {
    return (
      <Box className={classes.root}>
        <Loading />
      </Box>
    )
  }

  return (
    <Box className={classes.root}>
      <table className={classes.tableBase}>
        <thead className={classes.tableHeader}>
          <tr>
            <th className={classes.tableNameSize}>Fornecedores</th>
            <th className={classes.tableActionSize}></th>
          </tr>
        </thead>

        <tbody className={classes.tableBody}>
          {organizations.map((organization: IOrganizationDTO, index: number) => (
            <tr key={index}>
              <td className={classes.tableNameSize}>
                <Box className={classes.group}>
                  <Avatar {...stringToAvatar(organization.corporateName!, '#BDBDBD')} />
                  <Box className={classes.groupText}>
                    <span style={{ fontWeight: 600 }}>{organization.corporateName}</span>
                    <br />
                    <span className={classes.subTitle}>{organization.federalTaxId}</span>
                  </Box>
                </Box>
              </td>

              <td className={classes.tableActionSize}>
                <IconButton
                  icon={ArrowForwardIos}
                  onClick={() => handleNavigateToOrganization(organization.id!)}
                  tooltip='Visualizar'
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  )
}

export default Permissions
